import {
  Disclaimer,
  H3,
  Img,
  LoadingDots,
  Modal,
  P,
  importMenuImage,
} from '@vgrubs/components';
import React from 'react';
import { ProgressBarBackground, ProgressBarFill } from '../MenyStyled';

export const ImportLoaderModal = ({
  loading,
  setLoading,
  loadProgress,
  progress = false,
}: {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  loadProgress?: number;
  progress?: boolean;
}) => {
  return (
    <Modal
      exitButton={false}
      logo={false}
      isOpen={loading}
      width={'450px'}
      closeModal={() => setLoading(true)}
    >
      <Img alt="" src={importMenuImage} $width="250px" $mb="16" />
      <H3 $mb="12">
        <span>Menu is importing</span>
        <LoadingDots active={loading} />
      </H3>
      <P $mb="24">
        The menu is importing. This may take a few minutes. Please be patient.
      </P>
      {progress && (
        <>
          <ProgressBarBackground>
            <ProgressBarFill progress={loadProgress} />
          </ProgressBarBackground>
          <Disclaimer $m="0" $mt="8" $center>
            {loadProgress}%
          </Disclaimer>
        </>
      )}
    </Modal>
  );
};
